import { devConfigs } from "./dev.config";
import { prodConfigs } from "./prod.config";

const origin = window.location.origin;

export const configs = origin === 'https://act-umzug.randomwalktech.com' ? prodConfigs :  devConfigs;
